import type { ReactNode } from 'react';
import { Outlet } from 'react-router';
import { DEMO } from '../lib/demo.ts';
import { DemoBar } from '../pages/demo/Demo.tsx';
import { Sidebar, type NavItem } from './Sidebar.tsx';
import { Topbar } from './Topbar.tsx';
import s from './shell.module.css';

interface AppShellProps {
  items: NavItem[];
  home: string;
  sidebarTop?: ReactNode;
  topbarActions?: ReactNode;
  children?: ReactNode;
}

/** Vuokranantajan ja vuokralaisen yhteinen runko: sivupaneeli, yläpalkki ja sisältö. */
export function AppShell({ items, home, sidebarTop, topbarActions, children }: AppShellProps) {
  return (
    <div className={s.shell}>
      <Sidebar items={items} home={home} top={sidebarTop} />
      <div className={s.main}>
        {DEMO && <DemoBar />}
        <Topbar home={home} actions={topbarActions} />
        <main className={s.content}>{children ?? <Outlet />}</main>
      </div>
    </div>
  );
}
